import React from 'react';
import styles from './checkbox.module.css';
import Icon from "../../icons/icons";

const Checkbox = props => {
  return (
    <div className={styles.checkbox}>
      <React.Fragment>
        {props.items.data.map(item => (
          <React.Fragment key={item.id}>
            <input type="checkbox" id={item.id} name={item.name} value={item.value} className={styles.input_checkbox} onChange={props.onChange} />
            <label htmlFor={item.id} className={styles.label_checkbox}>
              {item.label}
              <Icon name="icon_checkbox" viewbox="0 0 24 24" />
            </label>
          </React.Fragment>
        ))}
      </React.Fragment>
    </div>
  )
}

export default Checkbox;